import { routes } from '@/features/v2/constants/routes';

export const core = {
  private: {
    navbarTabs: [
      {
        title: 'Inicio',
        href: routes.HOME,
        icon: '/img/v2/icons/home.webp',
      },
      {
        title: 'Casino',
        href: routes.CASINO,
        icon: '/img/v2/icons/card.webp',
      },
      {
        title: 'Deportes',
        href: routes.SPORTS,
        icon: '/img/v2/icons/ball.svg',
      },

      {
        title: 'Perfil',
        href: routes.DASHBOARD,
        icon: '/img/v2/avatar/avatar.webp',
      },
    ],
  },
};
